// The interface between the loader (widget.js) and the React panel
// (widget-panel.js). The panel bundle registers a `PanelModule` on
// `window.__aevoEchoPanel` when it evaluates; the loader then calls
// `render(host)` once. Both bundles are built from this repo at the same
// time, so the contract only has to hold within one build.

import type { PreviewPart } from './preview-protocol'
import type { WidgetStore } from './store'

export interface PanelHost {
  store: WidgetStore
  shadowRoot: ShadowRoot
  /** The element inside the `.se-panel` frame the panel renders into. */
  container: HTMLElement
  /** Where popovers and hover cards portal to (inside the shadow root). */
  portalContainer: HTMLElement
  serverUrl: string
  /** Studio preview: no socket, scripted content. */
  preview: boolean
  version: string
  close(): void
  /** Preview: the user clicked a part of the widget. */
  selectPart(part: PreviewPart, index?: number): void
}

export interface PanelHandle {
  destroy(): void
}

export interface PanelModule {
  render(host: PanelHost): PanelHandle
}

export const PANEL_GLOBAL = '__aevoEchoPanel' as const

declare global {
  interface Window {
    __aevoEchoPanel?: PanelModule
  }
}
